import { FC, PropsWithChildren } from 'react';

type FormErrorsPreviewErrorTargetProps = {
	targetName: string;
};

const FormErrorsPreviewErrorTarget: FC<PropsWithChildren<FormErrorsPreviewErrorTargetProps>> = ({
	children,
	targetName,
}) => {
	return <div data-error-target-name={targetName}>{children}</div>;
};

export default FormErrorsPreviewErrorTarget;
